import React, { lazy } from "react";

import { SettingsTabbedContent } from "../SettingsTabbedContent";

const AccountDetailsTab = lazy(() => import("./AccountDetails"));
const SubscriptionDetailsTab = lazy(() => import("./SubscriptionDetails"));

const tabs = [
  { label: "Details", path: "details", component: AccountDetailsTab },
  { label: "Subscription", path: "subscription", component: SubscriptionDetailsTab },
];

const AccountManagement: React.FC = () => {
  return <SettingsTabbedContent prefix="/settings/account" tabs={tabs} data-testid="account-management" />;
};

export default AccountManagement;
